import { Action } from '@ngrx/store';
import { Reference } from '../../utils/action-helper.util';
import { Error } from '../_models/auth.models';
import { UserDropDown } from '../_models/form.model';
import { CopyNotificationPayload, CopyNotificationResponse, Notification, NotificationError } from '../_models/notification.model';

/**
 * Notification action types
 */
export enum NotificationActionTypes {
  LOAD_NOTIFICATIONS = '[Notification] Load Notifications',
  LOAD_NOTIFICATIONS_SUCCESS = '[Notification] Load Notifications Success',
  LOAD_NOTIFICATIONS_FAILED = '[Notification] Load Notifications Failed',
  DELETE_NOTIFICATION = '[Notification] Delete Notification',
  DELETE_NOTIFICATION_SUCCESS = '[Notification] Delete Notification Success',
  DELETE_NOTIFICATION_FAILED = '[Notification] Delete Notification Failed',
  UPDATE_NOTIFICATION = '[Notification] Update Notification',
  UPDATE_NOTIFICATION_SUCCESS = '[Notification] Update Notification Success',
  UPDATE_NOTIFICATION_FAILED = '[Notification] Update Notification Failed',
  CREATE_NOTIFICATION = '[Notification] Create Notification',
  CREATE_NOTIFICATION_SUCCESS = '[Notification] Create Notification Success',
  CREATE_NOTIFICATION_FAILED = '[Notification] Create Notification Failed',
  LOAD_NOTIFICATION = '[Notification] Load Notification',
  LOAD_NOTIFICATION_SUCCESS = '[Notification] Load Notification Success',
  LOAD_NOTIFICATION_FAILED = '[Notification] Load Notification Failed',
  TEST_SUBSCRIPTION = '[Notification] Create Subscription',
  TEST_SUBSCRIPTION_SUCCESS = '[Notification] Create Subscription Success',
  TEST_SUBSCRIPTION_FAILED = '[Notification] Create Subscription Failed',
  EXISTS_NOTIFICATION = '[Notification] Exists Notification',
  EXISTS_NOTIFICATION_SUCCESS = '[Notification] Exists Notification Success',
  EXISTS_NOTIFICATION_FAILED = '[Notification] Exists Notification Failed',
  VIEW_NOTIFICATION_ERROR = '[Notification] View Notification Error',
  VIEW_NOTIFICATION_ERROR_SUCCESS = '[Notification] View Notification Error Success',
  VIEW_NOTIFICATION_ERROR_FAILED = '[Notification] View Notification Error Failed',
  DELETE_NOTIFICATION_ERROR = '[Notification] Delete Notification Error',
  DELETE_NOTIFICATION_ERROR_SUCCESS = '[Notification] Delete Notification Error Success',
  DELETE_NOTIFICATION_ERROR_FAILED = '[Notification] Delete Notification Error Failed',
  LOAD_WEBHOOKS = '[Notification] Load Webhooks',
  LOAD_WEBHOOKS_SUCCESS = '[Notification] Load Webhooks Success',
  LOAD_WEBHOOKS_FAILED = '[Notification] Load Webhooks Failed',
  COPY_NOTIFICATION = '[Notification] Copy Notification',
  COPY_NOTIFICATION_SUCCESS = '[Notification] Copy Notification Success',
  COPY_NOTIFICATION_FAILED = '[Notification] Copy Notification Failed',
  BULK_UPDATE_NOTIFICATIONS = '[Notification] Bulk Update Notification',
  BULK_UPDATE_NOTIFICATIONS_SUCCESS = '[Notification] Bulk Update Notification Success',
  BULK_UPDATE_NOTIFICATIONS_FAILED = '[Notification] Bulk Update Notification Failed',
  GET_EXECUTE_NOTIFICATION = '[Notification] Get Execute Notification',
  GET_EXECUTE_NOTIFICATION_SUCCESS = '[Notification] Get Execute Notification Success',
  GET_EXECUTE_NOTIFICATION_FAILED = '[Notification] Get Execute Notification Failed',
  RESET = '[Notification] RESET',
}

/**
 * Operations
 */
export class LoadNotifications implements Action {
  readonly type = NotificationActionTypes.LOAD_NOTIFICATIONS;

  constructor(public tableId: string, public force: boolean = false) {}
}

export class LoadNotificationsSuccess implements Action {
  readonly type = NotificationActionTypes.LOAD_NOTIFICATIONS_SUCCESS;

  constructor(public tableId: string, public payload: Array<Notification>) {}
}

export class LoadNotificationsFailed implements Action {
  readonly type = NotificationActionTypes.LOAD_NOTIFICATIONS_FAILED;

  constructor(public payload: Error, public tableId: string) {}
}

export class DeleteNotification extends Reference implements Action {
  readonly type = NotificationActionTypes.DELETE_NOTIFICATION;

  constructor(public tableId: string, public notificationId: string) {
    super();
  }
}

export class DeleteNotificationSuccess extends Reference implements Action {
  readonly type = NotificationActionTypes.DELETE_NOTIFICATION_SUCCESS;

  constructor(public tableId: string, public notificationId: string) {
    super();
  }
}

export class DeleteNotificationFailed extends Reference implements Action {
  readonly type = NotificationActionTypes.DELETE_NOTIFICATION_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class UpdateNotification extends Reference implements Action {
  readonly type = NotificationActionTypes.UPDATE_NOTIFICATION;

  constructor(public payload: Notification, public tableId: string = '') {
    super();
  }
}

export class UpdateNotificationSuccess extends Reference implements Action {
  readonly type = NotificationActionTypes.UPDATE_NOTIFICATION_SUCCESS;

  constructor(public payload: any, public tableId: string = '') {
    super();
  }
}

export class UpdateNotificationFailed extends Reference implements Action {
  readonly type = NotificationActionTypes.UPDATE_NOTIFICATION_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class CreateNotification extends Reference implements Action {
  readonly type = NotificationActionTypes.CREATE_NOTIFICATION;

  constructor(public payload: Notification) {
    super();
  }
}

export class CreateNotificationSuccess extends Reference implements Action {
  readonly type = NotificationActionTypes.CREATE_NOTIFICATION_SUCCESS;

  constructor(public payload: Notification) {
    super();
  }
}

export class CreateNotificationFailed extends Reference implements Action {
  readonly type = NotificationActionTypes.CREATE_NOTIFICATION_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class LoadNotification implements Action {
  readonly type = NotificationActionTypes.LOAD_NOTIFICATION;

  constructor(
    public tableId: string,
    public notificationId: any,
    public force: boolean = false
  ) {}
}

export class LoadNotificationSuccess implements Action {
  readonly type = NotificationActionTypes.LOAD_NOTIFICATION_SUCCESS;

  constructor(
    public tableId: string,
    public notificationId: string,
    public payload: Notification
  ) {}
}

export class LoadNotificationFailed implements Action {
  readonly type = NotificationActionTypes.LOAD_NOTIFICATION_FAILED;

  constructor(public payload: Error) {}
}

export class TestSubscription extends Reference implements Action {
  readonly type = NotificationActionTypes.TEST_SUBSCRIPTION;

  constructor(public payload: Notification) {
    super();
  }
}

export class TestSubscriptionSuccess extends Reference implements Action {
  readonly type = NotificationActionTypes.TEST_SUBSCRIPTION_SUCCESS;

  constructor(public result: any) {
    super();
  }
}

export class TestSubscriptionFailed extends Reference implements Action {
  readonly type = NotificationActionTypes.TEST_SUBSCRIPTION_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class ExistsNotification implements Action {
  readonly type = NotificationActionTypes.EXISTS_NOTIFICATION;

  constructor(public notificationId: string, public force: boolean = false) {}
}

export class ExistsNotificationSuccess implements Action {
  readonly type = NotificationActionTypes.EXISTS_NOTIFICATION_SUCCESS;

  constructor(public result: number) {}
}

export class ExistsNotificationFailed implements Action {
  readonly type = NotificationActionTypes.EXISTS_NOTIFICATION_FAILED;

  constructor(public payload: Error) {}
}

export class ViewNotificationError implements Action {
  readonly type = NotificationActionTypes.VIEW_NOTIFICATION_ERROR;

  constructor(public notificationId: string, public force: boolean = false) {}
}

export class ViewNotificationErrorSuccess implements Action {
  readonly type = NotificationActionTypes.VIEW_NOTIFICATION_ERROR_SUCCESS;

  constructor(
    public notificationId: string,
    public payload: Array<NotificationError>
  ) {}
}

export class ViewNotificationErrorFailed implements Action {
  readonly type = NotificationActionTypes.VIEW_NOTIFICATION_ERROR_FAILED;

  constructor(public payload: Error) {}
}

export class DeleteNotificationError extends Reference implements Action {
  readonly type = NotificationActionTypes.DELETE_NOTIFICATION_ERROR;

  constructor(public notificationId: string) {
    super();
  }
}

export class DeleteNotificationErrorSuccess
  extends Reference
  implements Action
{
  readonly type = NotificationActionTypes.DELETE_NOTIFICATION_ERROR_SUCCESS;

  constructor(public notificationId: string) {
    super();
  }
}

export class DeleteNotificationErrorFailed extends Reference implements Action {
  readonly type = NotificationActionTypes.DELETE_NOTIFICATION_ERROR_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class LoadWebhooks implements Action {
  readonly type = NotificationActionTypes.LOAD_WEBHOOKS;

  constructor(public tableId: string, public notificationId: string, public force: boolean = false) {}
}

export class LoadWebhooksSuccess implements Action {
  readonly type = NotificationActionTypes.LOAD_WEBHOOKS_SUCCESS;

  constructor(public tableId: string,  public notificationId: string, public payload: Array<UserDropDown>) {}
}

export class LoadWebhooksFailed implements Action {
  readonly type = NotificationActionTypes.LOAD_WEBHOOKS_FAILED;

  constructor(public payload: Error) {}
}
export class GetExecuteNotification extends Reference implements Action {
  readonly type = NotificationActionTypes.GET_EXECUTE_NOTIFICATION;

  constructor(public appId: string, public notificationId: string, public params: any) {
    super()
  }
}

export class GetExecuteNotificationSuccess extends Reference implements Action {
  readonly type = NotificationActionTypes.GET_EXECUTE_NOTIFICATION_SUCCESS;

  constructor(public appId: string,  public notificationId: string, public payload: any) {
    super()
  }
}

export class GetExecuteNotificationFailed extends Reference implements Action {
  readonly type = NotificationActionTypes.GET_EXECUTE_NOTIFICATION_FAILED;

  constructor(public payload: Error) {
    super()
  }
}

export class CopyNotification extends Reference implements Action {
  readonly type = NotificationActionTypes.COPY_NOTIFICATION;

  constructor(public tableId: string, public payload: any) {
    super();
  }
}

export class CopyNotificationSuccess extends Reference implements Action {
  readonly type = NotificationActionTypes.COPY_NOTIFICATION_SUCCESS;

  constructor(public payload: CopyNotificationResponse) {
    super();
  }
}

export class CopyNotificationFailed extends Reference implements Action {
  readonly type = NotificationActionTypes.COPY_NOTIFICATION_FAILED;

  constructor(public payload: Error) {
    super();
  }
}
export class BulkUpdateNotifications extends Reference implements Action {
  readonly type = NotificationActionTypes.BULK_UPDATE_NOTIFICATIONS;

  constructor(public payload: any) {
    super();
  }
}

export class BulkUpdateNotificationsSuccess extends Reference implements Action {
  readonly type = NotificationActionTypes.BULK_UPDATE_NOTIFICATIONS_SUCCESS;

  constructor(public payload: any) {
    super();
  }
}

export class BulkUpdateNotificationsFailed extends Reference implements Action {
  readonly type = NotificationActionTypes.BULK_UPDATE_NOTIFICATIONS_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class Reset implements Action {
  readonly type = NotificationActionTypes.RESET;

  constructor() {}
}

/**
 * Available types
 */
export type Actions =
  | LoadNotifications
  | LoadNotificationsSuccess
  | LoadNotificationsFailed
  | DeleteNotification
  | DeleteNotificationSuccess
  | DeleteNotificationFailed
  | UpdateNotification
  | UpdateNotificationSuccess
  | UpdateNotificationFailed
  | CreateNotification
  | CreateNotificationSuccess
  | CreateNotificationFailed
  | LoadNotification
  | LoadNotificationSuccess
  | LoadNotificationFailed
  | TestSubscription
  | TestSubscriptionSuccess
  | TestSubscriptionFailed
  | ExistsNotification
  | ExistsNotificationSuccess
  | ExistsNotificationFailed
  | ViewNotificationError
  | ViewNotificationErrorSuccess
  | ViewNotificationErrorFailed
  | DeleteNotificationError
  | DeleteNotificationErrorSuccess
  | DeleteNotificationErrorFailed
  | LoadWebhooks
  | LoadWebhooksSuccess
  | LoadWebhooksFailed
  | CopyNotification
  | CopyNotificationSuccess
  | CopyNotificationFailed
  | BulkUpdateNotifications
  | BulkUpdateNotificationsSuccess
  | BulkUpdateNotificationsFailed
  | GetExecuteNotification
  | GetExecuteNotificationSuccess
  | GetExecuteNotificationFailed
  | Reset;
